import { useFormikContext } from "formik";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import { CreateOfferData } from "../../../types/offers";
import TextField from "@mui/material/TextField";
import { Autocomplete } from "../../Autocomplete";
import { DateTimePicker } from "../../DateTimePicker";
import Stack from "@mui/material/Stack";
import { useQuery } from "react-query";
import {
  listAllDocuments,
  listInsights,
  listStores,
} from "../../../services/insights";
import { useState } from "react";

type InfosProps = {
  clientDocument?: string;
  storeId?: number;
};

export function Infos({ clientDocument, storeId }: InfosProps) {
  const formik = useFormikContext<CreateOfferData>();

  const [document, setDocument] = useState<string>(clientDocument);

  const stores = useQuery("stores", listStores, {
    enabled: !Boolean(storeId),
  });

  const insights = useQuery("insights", listInsights, {
    enabled: formik.values.type === "personalized",
  });

  const one_to_one = useQuery(
    ["one_to_one", document],
    () => {
      return listAllDocuments(document);
    },
    {
      enabled: formik.values.type === "one_to_one",
      onSuccess: (response) => {
        if (clientDocument) {
          formik.setFieldValue("clientOne2One", response[0]);
        }
      },
    }
  );

  const RenderPersonalized = () => {
    switch (formik.values.type) {
      case "personalized":
        return (
          <Autocomplete
            loading={insights.isLoading}
            size="small"
            label="Audiência"
            getOptionLabel={(option) => option.nameList}
            options={insights.data}
            onChange={(_, value) => {
              formik.setFieldValue("insight", value);
            }}
            value={formik.values.insight}
            error={!!formik.errors.insight}
            helperText={
              !!formik.errors.insight && (formik.errors.insight as string)
            }
          />
        );
      case "one_to_one":
        return (
          <Autocomplete
            loading={one_to_one.isLoading}
            size="small"
            label="Documento"
            placeholder="Digite o documento..."
            getOptionLabel={(option) => option.documento}
            onInputChange={(_, text) => setDocument(text)}
            options={one_to_one.data}
            onChange={(_, value) => {
              formik.setFieldValue("clientOne2One", value);
            }}
            value={formik.values.clientOne2One}
            error={!!formik.errors.clientOne2One}
            helperText={
              !!formik.errors.clientOne2One &&
              (formik.errors.clientOne2One as string)
            }
          />
        );
      default:
        return <></>;
    }
  };

  return (
    <Stack spacing={4}>
      <Typography color="primary">Informações</Typography>
      <TextField
        label="Nome"
        autoFocus
        onChange={({ target: { value } }) =>
          formik.setFieldValue("name", value)
        }
        fullWidth
        size="small"
        value={formik.values.name}
        error={!!formik.errors.name}
        helperText={!!formik.errors.name && formik.errors.name}
      />
      {one_to_one.isLoading || insights.isLoading ? (
        <Skeleton height={60} variant="text" />
      ) : (
        RenderPersonalized()
      )}
      <Autocomplete
        loading={stores.isLoading}
        multiple
        disabled={Boolean(storeId)}
        options={stores.data}
        getOptionLabel={(option) => option.nome_loja}
        size="small"
        label="Lojas"
        onChange={(_, value) => {
          formik.setFieldValue("stores", value);
        }}
        value={formik.values.stores}
        error={!!formik.errors.stores}
        helperText={!!formik.errors.stores && (formik.errors.stores as string)}
      />
      <Stack direction="row" spacing={2}>
        <DateTimePicker
          fullWidth
          size="small"
          label="Data de início"
          value={formik.values.startDate}
          onChange={(date) => formik.setFieldValue("startDate", date)}
          error={!!formik.errors.startDate}
          helperText={
            !!formik.errors.startDate && (formik.errors.startDate as string)
          }
        />
        <DateTimePicker
          disablePast
          fullWidth
          size="small"
          label="Data de término"
          value={formik.values.endDate}
          onChange={(date) => formik.setFieldValue("endDate", date)}
          error={!!formik.errors.endDate}
          helperText={
            !!formik.errors.endDate && (formik.errors.endDate as string)
          }
        />
      </Stack>
    </Stack>
  );
}
